import { type ContextBlockProps } from './ContextBlock.types';
import ContextBlockImage from './ContextBlockImage';
import ContextBlockContent from './ContextBlockContent';
import ContentTile from './ContentTile';

const ContextBlock: React.FC<ContextBlockProps> = ({
  hideMainContent,
  hideImageOnMobile,
  isImageSideSwapped,
  showTitle,
  title,
  image,
  imageSize,
  content,
  linkTitle,
  linkURL,
  items,
}) => {
  return (
    <div className="context-block">
      {!hideMainContent && (
        <div
          className={`context-block__main ${isImageSideSwapped ? 'context-block__main--image-right' : ''}`}
        >
          <div
            className={`context-block__main-section ${isImageSideSwapped ? 'context-block__main-section--content-left' : ''}`}
          >
            {!isImageSideSwapped ? (
              <ContextBlockImage
                image={image}
                imageSize={imageSize}
                hideOnMobile={hideImageOnMobile}
              />
            ) : (
              <ContextBlockContent
                showTitle={showTitle}
                title={title}
                content={content}
                linkTitle={linkTitle}
                linkURL={linkURL}
              />
            )}
          </div>
          <div
            className={`context-block__main-section ${!isImageSideSwapped ? 'context-block__main-section--content-right' : ''}`}
          >
            {!isImageSideSwapped ? (
              <ContextBlockContent
                showTitle={showTitle}
                title={title}
                content={content}
                linkTitle={linkTitle}
                linkURL={linkURL}
              />
            ) : (
              <ContextBlockImage
                image={image}
                imageSize={imageSize}
                hideOnMobile={hideImageOnMobile}
              />
            )}
          </div>
        </div>
      )}
      {items && items.length > 0 && (
        <div className="context-block__columns">
          {items.map((item, index) => (
            <ContentTile key={index} {...item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ContextBlock;
